import JassHandle from './handle';

/**
 * type agent
 */
export default class JassAgent extends JassHandle {}
